import { cn } from '#app/utils/misc'

type ProviderIconName = 'google' | 'apple' | 'facebook'

/**
 * The provider marks on the social buttons. Google is its multi-colour
 * asset; Apple draws in `currentColor` (white on the black button); the
 * Facebook "f" is cut out of the brand-blue circle.
 */
export function ProviderIcon({
	provider,
	className,
}: {
	provider: ProviderIconName
	className?: string
}) {
	const size = cn('h-[22px] w-[22px] shrink-0', className)
	if (provider === 'google') {
		return (
			<img
				src="/img/google-icon.svg"
				alt=""
				width={22}
				height={22}
				className={size}
			/>
		)
	}
	if (provider === 'apple') {
		return (
			<svg
				viewBox="0 0 24 24"
				aria-hidden="true"
				fill="currentColor"
				className={size}
			>
				<path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
			</svg>
		)
	}
	return (
		<svg viewBox="0 0 24 24" aria-hidden="true" className={size}>
			<path
				fill="#0866FF"
				d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
			/>
		</svg>
	)
}
